module.exports = __webpack_public_path__ + "static/5-b095d278b54e5a3bd8b36da0d348fc4a.png";